import { WinStreakRoadPopup } from '../views/WinStreakRoadPopup';
import { getChestToOpenIndex, openChest, winSteakNoteUserSawProgress } from '../WinStreakUtils';
import { endWinStreakAndOpenShare } from './endWinStreakAndOpenShare';
import { preloadLayoutsAssets } from '../../../views/preloadLayoutsAssets';
import type { WinStreakDependencies } from '../WinStreakController';

interface OpenWinStreakRoadConfig {
  dependencies: WinStreakDependencies;
  onPlayClicked: () => void;
  intro: boolean;
}

export async function openWinStreakRoadPopup({
  dependencies,
  onPlayClicked,
  intro,
}: OpenWinStreakRoadConfig): Promise<void> {
  const { observable, popupsController, addResources } = dependencies;

  const winStreakState = observable.getValue().winStreakActiveEvent;

  if (!winStreakState) return Promise.resolve();

  if (!(await preloadLayoutsAssets(WinStreakRoadPopup.requiredLayouts, true))) return Promise.resolve();

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  const popup = new WinStreakRoadPopup({
    levelNumber: observable.getValue().levelIndex + 1,
    winStreakState,
    chestToOpen: getChestToOpenIndex(winStreakState),
    intro,
  });

  popup.onAnimationFinished.connect(() => {
    const rewards = openChest(dependencies.observable);
    if (!rewards) return;
    addResources(rewards, winStreakState.id ?? '');
  });

  popup.onCloseClicked.connect(async () => {
    await popupsController.closeActivePopup();

    if (observable.getValue().winStreakActiveEvent?.finished) {
      await endWinStreakAndOpenShare(dependencies);
    }
    resolve();
  });
  popup.onPlayClicked.connect(async () => {
    await popupsController.closeActivePopup();

    if (observable.getValue().winStreakActiveEvent?.finished) {
      await endWinStreakAndOpenShare(dependencies);
    }

    onPlayClicked();
  });

  void popupsController.addPopup(popup);

  winSteakNoteUserSawProgress(dependencies.observable);

  return promise;
}
